import { Observable } from 'rxjs';
import { T22EntityItemDTO } from 'src/app/store/order/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractEntityService {
  public abstract getValuesByMask(entityId: number, mask: string): Observable<InteractorResponse<T22EntityItemDTO[]>>;
  public abstract getAllValues(entityId: number): Observable<InteractorResponse<T22EntityItemDTO[]>>;
}
